module.exports = __webpack_public_path__ + "static/img/1_0024.0f5f002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0024.jpg
// module id = QZ82
// module chunks = 0